const isDev = import.meta.env.DEV;

const chatbotUrl = isDev ? import.meta.env.VITE_CHATBOT_URL : "https://chatbothub.telekom.gr/chathub/chat/";

const registerUrl = isDev
  ? import.meta.env.VITE_REGISTER_URL
  : "https://account.telekom.gr/register?nakedAuthorization";

export { isDev, chatbotUrl, registerUrl };
